import Cookies from 'js-cookie'

const CC_COOKIE_NAME = 'cc_cookie'

/**
 * Reads the cc_cookie set by the parent app's cookie consent banner.
 * Returns true only if the cookie exists AND analytics is accepted.
 */
export function hasAnalyticsConsent(): boolean {
  try {
    const raw = Cookies.get(CC_COOKIE_NAME)
    if (!raw) return false
    const parsed = JSON.parse(decodeURIComponent(raw))
    return (
      Array.isArray(parsed.categories) &&
      parsed.categories.includes('analytics')
    )
  } catch {
    return false
  }
}

/**
 * Returns true when a consent decision exists anywhere on the domain,
 * regardless of what was chosen. Used to suppress a fallback banner for
 * visitors who already decided on another surface (e.g. the community
 * landing page) sharing the same cc_cookie.
 */
export function hasConsentDecision(): boolean {
  return Boolean(Cookies.get(CC_COOKIE_NAME))
}

/**
 * True when this widget is running inside the native app's sign-up flow.
 *
 * The app opens us with `WebBrowser.openAuthSessionAsync(..., {
 * preferEphemeralSession: true })`, so the cookie jar is deliberately fresh
 * every time and nothing we write survives the session. A banner there blocks
 * sign-up, cannot be answered in any lasting way, and reappears on every
 * attempt — while buying nothing, since the app measures with the Firebase SDK
 * rather than our cookies. Consent for that traffic belongs to the app.
 *
 * `type` is read from localStorage first, matching how Signup.tsx resolves it:
 * the query param is lost across OAuth redirects, so it is stashed on arrival.
 */
export function isNativeAppSession(): boolean {
  try {
    const stashed = localStorage.getItem('type')
    if (stashed && stashed !== 'null') return stashed === 'mobile'
    return new URLSearchParams(window.location.search).get('type') === 'mobile'
  } catch {
    return false
  }
}
